<template>
  <div style="height:100%;">

    <el-container style="height:100%;border:1px solid #eee;">

      <div class="new-scroll1" style="height: 100%;_background: #eef1f6;">
        <el-aside :style="{'width':logoWidth,'height':'100%'}">
          <el-scrollbar style="height: 100%;overflow-x: hidden; ">
            <div class="header2">
              <el-image style="width: 150px;height: 26px" :src="logo"/>
            </div>
<!--            <el-header class="header2">-->
<!--              <el-row type="flex" justify="space-around" align="middle" :span="24" style="margin-top:0px;width:100%;">-->
<!--                <el-col :md="24" style="text-align: left;margin-left:5px;">-->
<!--                  <el-image style="width: 150px;height: 26px" :src="logo"/>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </el-header>-->
            <index-left ref="left" @parent_method="rightAddTab"></index-left>
          </el-scrollbar>

        </el-aside>
      </div>

      <el-container style="height:100%;margin:0px;">
        <el-header class="header1" :style="{'padding-left':'0px','background': '#ffffff'}">
          <el-row type="flex" justify="space-between" align="middle" :span="24" style="margin-top:0px;height: 60px;">
            <el-col :md="3" style="text-align: left">
              <!--              <span style="color:#ffffff;font-size: 20px;" :class="icon1"  @click="openCloseMenu"> </span>-->
              <el-link style="color:#ffffff;font-size: 20px;height: 60px;line-height:60px;" :icon="icon1" :underline="false" @click="openCloseMenu"></el-link>
            </el-col>

            <el-col v-show="false" :md="16">
              <index-left2 v-show="true" ref="left_2" @parent_method="rightAddTab"></index-left2>
            </el-col>

            <el-col :md="5" style="margin-right:30px;">
              <div style="display: flex;justify-content: flex-end;align-items: center;">
                <span style="font-size: 16px;text-decoration:underline;cursor: pointer;" v-if="customGlobal.userInfoExt.cui_type!=='0'&&customGlobal.userInfoExt.cui_type!=='1'" @click="QRCodeShow=true">小程序登录二维码</span>
                <span >&#12288;{{this.customGlobal.userInfoExt.cui_realname}}&#12288;&#12288;</span>
                <el-dropdown @command="dropdownCommand" trigger='click' style="display: flex;align-items: center;">
                    <el-image style="width: 26px;height: 26px;cursor: pointer;" :src="dd"/>
<!--                  <span class="el-dropdown-link  fa fa-tasks" style="font-size: 20px;">-->
<!--                  </span>-->
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-key" command="resetPassword">修改密码</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-s-home" command="exit">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

            </el-col>

          </el-row>

        </el-header>

        <el-container style="height:100%;margin:0px;">
          <el-aside style="width: 1px;background: #E3E5EB">
          </el-aside>
          <el-main style="padding:0px;">
            <index-right ref="right" @parent_method2="leftActiveMenu"></index-right>
          </el-main>

        </el-container>

      </el-container>
    </el-container>

    <el-dialog :visible.sync="dialogFormVisible2" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false" width="600px" class="dialogBox">
      <div slot="title" style="text-align: left;font-size:20px;font-weight: bold;">
        <span>修改密码</span>
      </div>
      <el-form label-position="right" :model="changePassForm1" :rules="changePassRules1" ref="changePassForm1" label-width="130px" style="width: 500px;margin: 0 auto;">
        <el-form-item label="原登录密码:" prop="password">
          <el-input type="password" v-model="changePassForm1.password" :rules="changePassRules1.password"></el-input>
        </el-form-item>
        <el-form-item label="新登录密码:" prop="newPassword">
          <el-input type="password" v-model="changePassForm1.newPassword" :rules="changePassRules1.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认新登录密码:" prop="confirmPassword">
          <el-input type="password" v-model="changePassForm1.confirmPassword" :rules="changePassRules1.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="resetPassword('changePassForm1')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogFormVisible3" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" width="25%">
      <div style="width:100%;height: 350px;text-align: center;">
        <wx-get-code :key="refreshImg"></wx-get-code>
      </div>

    </el-dialog>
    <el-dialog :visible.sync="QRCodeShow" :close-on-press-escape="false" :show-close="true" width="1000px">
      <div style="width:100%;height: 350px;text-align: center;">
        <QRCode v-if="QRCodeShow"></QRCode>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import IndexLeft from "../components/index/IndexLeft";
import IndexLeft2 from "../components/index/IndexLeft2";
import IndexRight from "../components/index/IndexRight";
import WxGetCode from "../components/index/right/WxGetCode";
import QRCode from "../components/views/components/QRCode.vue";
import Bus from "../utils/Bus";
export default {
  name: "index",
  // components:{IndexRight, IndexLeft,IndexLeft2},
  components: { WxGetCode, IndexRight, IndexLeft, IndexLeft2, QRCode },
  // inject:['reload'],
  data() {
    var validatePassword = (rule, value, callback) => {
      // 密码正则  // 6-10位数字、字母或数字+字母组合
      let zmReg = /[A-Za-z]/; // 大小写字母
      let numReg = /[0-9]/; // 数字
      let empty = /\s/g;
      let chinese = /[\u4e00-\u9fa5]/g;
      let i = 0;
      if (chinese.test(value)) {
        return false;
      }
      if (empty.test(value)) {
        return false;
      }
      if (zmReg.test(value)) {
        i++;
      }
      if (numReg.test(value)) {
        i++;
      }
      if (i > 0 && value.length > 5 && value.length < 11) {
        callback();
      } else {
        callback(new Error('请输入6-10位数字、字母或数字+字母组合'));
      }
    };
    var confirmPassword = (rule, value, callback) => {
      if (this.changePassForm1.newPassword == value) {
        callback();
      } else {
        callback(new Error('两次输入的密码不一致，请重新输入'));
      }
    };
    return {
      logo: require('@/assets/images/logo.png'),
      dd: require('@/assets/images/tx.png'),
      QRCodeShow: false,
      // winClientHeight :(document.documentElement.clientHeight),
      refreshImg: new Date().getTime(),
      systemDic: {
        defaultImg: require("@/assets/images/defaultLogo.jpg"),
        logoImg: this.customGlobal.serverUrl.orgBaseURI + "/fr/imgserver/" + this.customGlobal.systemDictionary.logo_img,
        logoName: this.customGlobal.systemDictionary.company_name,
      },
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

      icon1: 'fa fa-outdent',
      icon2: 'fa fa-dedent',
      logoWidth: '210px',
      headBackground: '#0D5788',
      dropDownColor: '#000000',
      // bodyBgImage: 'url(' + require('@/assets/images/login_bg2.jpg') + ')'
      //loading:true,


      dialogFormVisible2: false,
      dialogFormVisible3: false,
      changePassForm1: {
        password: '',
        newPassword: '',
        confirmPassword: '',
      },
      changePassRules1: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: confirmPassword, trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    dialogFormVisible2() {
      this.changePassForm1.password = ''
      this.changePassForm1.newPassword = ''
      this.changePassForm1.confirmPassword = ''
    }
  },
  destroyed() {
    Bus.$off('globalMsgForTabPage');
    // window.removeEventListener('beforeunload', e => this.test(e))
  },
  created() {
    let that = this;
    let isdl = this.$route.query.isdl
    console.log("进入PC端--------------", isdl)
    if (isdl) {
      this.$router.push({path:'/index'})
      window.location.reload()
    }
    Bus.$on('globalMsgForTabPage', function (val) {//监听各组件传递的 globalMsg 事件
      // console.log("监听到的消息："+JSON.stringify(val));
      console.info("val:" + JSON.stringify(val))
      if (val.method === 'open') {
        that.$refs['right'].removeTab(val.id)
        that.$refs['right'].addTab(val)
      } else if (val.method === 'close') {
        that.$refs['right'].removeTab(val.id)
      }
    });
    //this.stopF5Refresh();
    //window.addEventListener('beforeunload', e => this.test(e),false);
    // setTimeout(() => {
    //   this.loading = false;
    // }, 2000);
    // document.body.className = "custom-1";

    let theme = window.localStorage.getItem('theme');

    if (theme == 'custom-0') {//默认
      this.headBackground = '#0D5788';
      this.dropDownColor = '#000000';
    } else if (theme == 'custom-1') {
      this.headBackground = '';
      this.dropDownColor = '#ffffff';
    } else {

      this.headBackground = '#0D5788';
      this.dropDownColor = '#000000';
    }

    if (theme) {
      document.body.className = theme;
    }

  },

  mounted() {

    // document.body.style.backgroundImage = this.bodyBgImage;
    let that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->

    window.addEventListener("resize", function () {
      window.fullHeight = document.documentElement.clientHeight;
      window.fullWidth = document.documentElement.clientWidth;
      that.windowHeight = window.fullHeight + 'px';  // 高
      that.windowWidth = window.fullWidth; // 宽
      that.customGlobal.win_w_h = { width: that.windowWidth, height: that.windowHeight };
      console.info("win_w_h:" + JSON.stringify(that.customGlobal.win_w_h));
    });
    //刷新后重新加载
    let currentTab = window.sessionStorage.getItem('currentTab');
    if (currentTab) {
      // this.rightAddTab(JSON.parse(currentTab));
      // this.$refs['right'].addTab(JSON.parse(currentTab));

      this.$refs['right'].addTab(JSON.parse(this.customGlobal.decrypt(currentTab, this.customGlobal.cryptoKey)));
    }
  },
  methods: {
    leftActiveMenu(args) {
      this.$refs['left'].activeMenu(args);
    },
    rightAddTab(args) {//一个参数

      //alert("父组件接受子组件的内容："+JSON.stringify(args));
      this.$refs['right'].addTab(args);
      //alert("父组件接受子组件的内容："+ args);
    },
    openCloseMenu() {
      this.$refs['left'].openCloseMenu();;
      if (this.$refs['left'].menuCollapse) {
        this.icon1 = "fa fa-indent";
        this.logoWidth = '60px';
      } else {
        this.icon1 = "fa fa-outdent";
        this.logoWidth = '210px';

      }
    },
    closeForm() {
      this.dialogFormVisible2 = false;
      this.$refs.changePassForm1.clearValidate();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();

    },
    resetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let md5password = this.customGlobal.md5(this.changePassForm1.password);
          let newPassword = this.customGlobal.md5(this.changePassForm1.newPassword);
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            target: '.main',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, .7)'
          });
          var p1 = this.customGlobal.postHttpClient(
            this.customGlobal.serverUrl.postChangeMerPasswd2Bank,
            //this.customGlobal.serverUrl.baseURI,
            this.customGlobal.serverUrl.orgBaseURI,
            { "Content-Type": "application/x-www-form-urlencoded" },
            this.qs.stringify({ jsondata: JSON.stringify({ username: this.customGlobal.userInfoExt.cui_login_id, password: md5password, password_new: newPassword }) })
          );

          p1.then((res) => {
            if (res.data.status == 'success') {
              this.dialogFormVisible2 = false;
              this.$message({
                type: 'success',
                showClose: true,
                duration: 3000,
                dangerouslyUseHTMLString: true,
                message: '<span style="color:black;"> 修改密码成功</span>'
              });
              loading.close();

            } else {
              this.$message({
                type: 'warning',
                showClose: true,
                duration: 3000,
                dangerouslyUseHTMLString: true,
                message: `<span style="color:black;">${res.data.msg}</span>`
              });
              loading.close();
            }
          }, error => {
            console.log("异步调用出错:" + JSON.stringify(error));
            loading.close();
            this.$message({
              type: 'warning',
              showClose: true,
              duration: 3000,
              dangerouslyUseHTMLString: true,
              message: '<span style="color:black;"> 修改密码失败</span>'
            });
          }).catch((res) => {
            console.log("异步调用失败返回:" + JSON.stringify(res));
            loading.close();
            this.$message({
              type: 'warning',
              showClose: true,
              duration: 3000,
              dangerouslyUseHTMLString: true,
              message: '<span style="color:black;"> 修改密码失败</span>'
            });
          });
        } else {

          return false;
        }
      });
    },
    dropdownCommand(cmd) {
      //this.$message('click on item ' + cmd);
      if (cmd === 'changeskin2') {//默认
        document.body.className = "custom-0";
        window.localStorage.setItem('theme', "custom-0");
        this.headBackground = '#0D5788';
        this.dropDownColor = '#000000';

      } else if (cmd === 'changeskin1') {//深蓝
        document.body.className = "custom-1";
        window.localStorage.setItem('theme', "custom-1");
        this.headBackground = '';
        this.dropDownColor = '#ffffff';


      } else if (cmd === 'exit') {
        var p1 = this.customGlobal.postHttpClient(
          this.customGlobal.serverUrl.postMerLoginSessionClear,
          this.customGlobal.serverUrl.orgBaseURI,
          { "Content-Type": "application/json" },
          {});
        this.customGlobal.userInfo = { username: "null", authed: "failed" };
        window.sessionStorage.clear();
        this.$router.push({ path: '/login' });

      } else if (cmd === 'resetPassword') {
        this.changePassForm1.password = '';
        this.dialogFormVisible2 = true;
      } else if (cmd === 'bindwx') {
        this.refreshImg = new Date().getTime();
        this.dialogFormVisible3 = true;
      }
    },

  },

}
</script>

<style scoped>
/*<style >*/

.header1 {
  padding: 0px;
  height: 60px;
  line-height: 60px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #797979;
}
.header2 {
  display: flex;
  align-items: center;
  padding-left: 5px;
  height: 59px;
  font-size: 14px;
  border-bottom: 1px solid #797979;
}

/*隐藏滚动条*/
.is-horizontal {
  display: none;
}
.el-dropdown-link {
  cursor: pointer;
  /*color: #409EFF;*/
  color: #ffff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-link {
  text-decoration: none !important;
}

.new-scroll1 /deep/ .el-aside > .el-scrollbar > .el-scrollbar__wrap {
  overflow-x: hidden !important;
  /*overflow-y: hidden !important;*/
}
/*.new-scroll1 /deep/ .el-aside>.el-scrollbar>.el-scrollbar__wrap {*/
/*  overflow-x: hidden !important;*/
/*  overflow-y: hidden !important;*/
/*}*/
.dialogBox /deep/ .el-form-item {
  margin-bottom: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue